import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import {
  inject,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  type ApplicationConfig,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Router, provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAppFooter } from '@sbe-spinoff-client/app-footer';
import { provideAppShell, withNoMatchRedirect } from '@sbe-spinoff-client/app-shell';
import {
  provideStaffHttpApiBaseUrl,
  staffApiBaseUrlInterceptor,
  staffCredentialsInterceptor,
} from '@sbe-spinoff-client/staff-http';
import { provideStaffOidcAuth, staffBearerInterceptor } from '@sbe-spinoff-client/staff-oidc-auth';
import { appRoutes } from './app.routes';
import { environment } from './environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    // subscribe 21건 전부 signal.set()/.update()로 귀결(paramMap 구독 포함 — id는 signal에
    // 저장). NgZone·타이머 사용 없음.
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideStaffHttpApiBaseUrl(() => environment.apiBaseUrl),
    provideHttpClient(withXhr(), 
      withInterceptors([
        staffApiBaseUrlInterceptor,
        staffCredentialsInterceptor,
        // Bearer 부착 + 401 시 refresh 1회 재시도. 세션이 끝났으면 `signIn` 으로 /login 이동(이전 staffRedirectOn401Interceptor 의 역할을 포함).
        staffBearerInterceptor,
      ]),
    ),
    // 이 앱은 SSO 가 아니라 자체 로그인 화면(/login)을 쓴다 — 세션 복원·refresh·로그아웃만 공용 lib 에 맡긴다.
    provideStaffOidcAuth({
      signIn: (returnPath) => {
        void inject(Router).navigate(['/login'], { queryParams: { return: returnPath } });
      },
      // OIDC 확인 화면(`OauthAuthorizeComponent`)이 이 호출의 401 을 스스로 처리한다 — 인터셉터의 이동과 화면을 다투지 않게 한다.
      handlesUnauthorized: (url) => /\/oauth\/interaction\/[^/]+\/staff-login/.test(url),
    }),
    provideRouter(appRoutes, withComponentInputBinding(), withNoMatchRedirect()),
    provideAppFooter({
      statusAppSlug: 'schoolbell-e',
      linkGroups: [
        {
          title: '내부',
          links: [{ label: 'Observability', href: 'https://observability.schoolbell-e.com' }],
        },
      ],
    }),
    provideAppShell({ showThemeToggle: true }),
  ],
};
